import { gql } from "apollo-boost"

export const updateValoration = gql`
mutation UpdateValoration($data: CreateValorationInput!, $id: String!){
  UpdateValoration(data: $data, id: $id)
}
`